import React from 'react';
import { usePageMeta } from '../hooks/usePageMeta';
import { Reveal } from '../components/ui-kit/Reveal';

const Block = ({ title, children }) => (
  <section className="mt-10 first:mt-0">
    <Reveal>
      <h2 className="text-h3 text-ink">{title}</h2>
    </Reveal>
    <Reveal delay={60}>
      <div className="mt-3 text-body text-ink-muted space-y-3 max-w-2xl">{children}</div>
    </Reveal>
  </section>
);

const Kayttoehdot = () => {
  usePageMeta({
    title: 'Agencive – Käyttöehdot',
    description:
      'Agenciven verkkosivuston ja palvelutietojen käyttöehdot.',
    path: '/kayttoehdot',
  });
  const updated = '25.6.2026';

  return (
    <main className="bg-bg">
      <section className="pt-28 md:pt-32 pb-20 md:pb-24">
        <div className="container-page max-w-3xl">
          <Reveal>
            <span className="eyebrow text-ink-muted">Käyttöehdot</span>
          </Reveal>
          <Reveal delay={80}>
            <h1 className="mt-5 text-h1 text-ink">Käyttöehdot</h1>
          </Reveal>
          <Reveal delay={140}>
            <p className="mt-5 text-body-lg text-ink-muted">
              Nämä ehdot koskevat agencive.fi-verkkosivun käyttöä. Käyttämällä sivustoa
              hyväksyt nämä ehdot. Päivitetty {updated}.
            </p>
          </Reveal>

          <Block title="Sivuston käyttö">
            <p>Sivusto on tarkoitettu tiedon tarjoamiseen ja yhteydenpitoon. Sivuston käyttö on sallittua omaan, ei-kaupalliseen käyttöön. Sivuston häiritseminen tai luvaton käyttö on kielletty.</p>
          </Block>

          <Block title="Yhteydenottolomake">
            <p>Yhteydenottolomakkeen kautta lähettämiäsi tietoja käsitellään tietosuojaselosteen mukaisesti. Käytämme tietoja vain vastataksemme yhteydenottoosi.</p>
          </Block>

          <Block title="Palvelutiedot eivät ole sitova tarjous">
            <p>Sivustolla esitetyt palvelukuvaukset, hinnat ja muut tiedot ovat suuntaa-antavia, eivätkä ne muodosta sitovaa tarjousta. Tarkat tiedot sovitaan aina erillisellä sopimuksella tai vahvistuksella.</p>
          </Block>

          <Block title="Vastuunrajoitus">
            <p>Pyrimme pitämään sivuston tiedot ajantasaisina ja virheettöminä, mutta emme vastaa epäsuorista tai välillisistä vahingoista, jotka aiheutuvat sivuston käytöstä tai sen sisältämistä tiedoista.</p>
          </Block>

          <Block title="Immateriaalioikeudet">
            <p>Sivuston sisältö, kuvat, teksti, logot ja brändielementit ovat Agencive AI Oy:n tai sen lisenssinantajien omaisuutta. Sisältöä ei saa kopioida tai käyttää ilman erillistä lupaa.</p>
          </Block>

          <Block title="Ehtojen muutokset">
            <p>Voimme päivittää näitä ehtoja toimintamme kehittyessä. Ajantasaisin versio on aina tällä sivulla.</p>
          </Block>

          <Block title="Yhteystiedot">
            <p>Kysymykset ehdoista: <a className="text-brand hover:text-brand-hover underline" href="mailto:agencive.ai@gmail.com">agencive.ai@gmail.com</a> · +358 40 1601975 · Lempäälä, Pirkanmaa.</p>
          </Block>
        </div>
      </section>
    </main>
  );
};

export default Kayttoehdot;
